import React from "react"
import { useNavigate } from "react-router-dom"
import Gutters1 from "../assets/gutters01.jpg"
import Gutters2 from "../assets/gutters02.jpg"
import Image3 from "../assets/image3.jpg"
import Image4 from "../assets/image4.jpg"
import Image5 from "../assets/image5.jpg"
import Image7 from "../assets/image07.jpg"
import Image8 from "../assets/image08.jpg"
import { MessageSquare } from "lucide-react"
import "./styles/Gutters.css"

function Gutters() {
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/contact")
  }

  return (
    <div className="gutters-container">
      <div className="products-title">Seamless Gutters</div>
      <div className="gutters-content">
        <div className="gutters-images">
          <img
            src={Gutters1}
            alt="First Description"
            className="gutters-image"
          />
          <img
            src={Gutters2}
            alt="Second Description"
            className="gutters-image"
          />
        </div>
        <div className="gutters-text">
          <p className="gtext">
            Manny&rsquo;s Seamless Gutters, Inc. specializes in the expert
            installation of one-piece gutters based in Long Island, across New
            York, New Jersey, and Connecticut. Our seamless gutters are crafted
            using our state-of-the-art gutter machine, ensuring a perfect fit
            for every property. The unique design of these gutters means there
            are no breaks or joints, reducing the chance of sagging or leaking.
            They&rsquo;re tailored on-site for each project, ensuring a precise
            fit. The only connections are at corners and downspout outlets,
            ensuring a more secure and leak-resistant system.
          </p>
          <p className="gtext">
            The continuous design of seamless gutters not only provides strength
            but also offers a cleaner, more streamlined appearance. And the main
            advantage? No joints translate to no leaks.
          </p>
          <p className="gtext">
            Our seamless gutters are crafted to the highest standards. You can
            choose from a range of colors in durable aluminum to complement your
            {/* property&rsquo;s exterior, or opt for the classic look of copper. */}
            The paint used on our aluminum gutters undergoes a specialized
            process, ensuring it remains vibrant and intact for up to 20 years
            without chipping, cracking, or blistering. Think of the convenience
            of not needing to repaint your gutters for two decades!
          </p>
          <p className="gtext">
            For a complimentary quote on gutter installation, reach out to
            Manny&rsquo;s Seamless Gutters, Inc. We also provide downspout and
            extension installations. Give us a call at (123) 456-7890 or Book Us
            Online Below.
          </p>
        </div>
        <div className="landing-quote">
          <p className="contactus">Bonded & Insured</p>
          <button className="landing-quote-btn" onClick={handleButtonClick}>
            <MessageSquare />
            Book Online Now!
          </button>
          <p className="contactus">Free Consultations</p>
        </div>
      </div>
      <div className="house-images">
        <img src={Image7} alt="Third Description" className="house-image" />
      </div>
      <h2 className="chopDropTitle">Chop &amp; Drop</h2>
      <div className="gutters-text">
        <p className="gtext">
          Our team stands ready to assist with your seamless gutter needs.
          Whether you&apos;re a homeowner who needs installation, a contractor
          who needs supply and on-site delivery, or a professional gutter
          company, we&apos;re here to provide top-notch seamless gutters for
          installations, replacements, or construction endeavors. Our commitment
          is to offer the best products in the market, simplifying the process
          of residential gutter transactions in the Tri-State Area.
        </p>
        <p className="gtext">
          The continuous design of seamless gutters not only provides strength
          but also offers a cleaner, more streamlined appearance. And the main
          advantage? No joints translate to no leaks.
        </p>
        <p className="gtext">
          At Manny&rsquo;s Seamless Gutters, we&apos;re revolutionizing the
          industry with our tailor-made and promptly delivered seamless gutters.
          We recognize the pivotal role gutters play in safeguarding your
          home&rsquo;s structure and aesthetics. Our gutters are designed to be
          both visually appealing and durable.
        </p>
        <div className="house-images">
          <img src={Image8} alt="Fourth Description" className="house-image" />
        </div>
        <p className="gtext">
          With us, you can be assured of receiving premium seamless gutters
          without compromising on quality, delivered punctually to your
          location. Reach out to Manny&rsquo;s Seamless Gutters to discover more
          about our innovative gutter production and distribution services. Our
          experts will guide you in selecting the ideal materials, designs, and
          accessories, and ensure they&apos;re delivered directly to you. Your
          journey to a seamless gutter solution starts with Manny&rsquo;s
          Seamless Gutters. Let us empower you to achieve more with less effort!
        </p>
      </div>
      <div className="bottom-section">
        <div className="gutters-text">
          <h2 className="chopDropTitle">Time Value & Selection</h2>
          <p className="gtext">
            Finding top-quality materials and tools for gutter installations can
            be a daunting task. The challenges of supply chain disruptions and
            subpar manufacturing can turn the simple act of sourcing the right
            gutters into a risky venture. And even when you do locate them, they
            often come in sizes that require adjustments to fit your
            specifications.
          </p>
          <p className="gtext">
            Manny&rsquo;s Seamless Gutters understands the value of time and is
            committed to streamlining this process for you. We&apos;re here to
            ensure you and your clients have access to the finest seamless
            gutters in the market. Catering to all your gutter requirements, we
            offer a diverse selection in terms of colors, sizes, and materials,
            ensuring you find the perfect fit for your project.
          </p>
          <p className="gtext">
            Our suite of services for residential seamless gutter provision and
            delivery encompasses:
          </p>
          <div className="gutter-styles">
            <ul>
              <li>K-Style Gutters</li>
              <li>Gutter Guards</li>
              <li>Leaders</li>
              <li>Soffits</li>
              <li>Downspouts</li>
              <li>Downspout Strainers</li>
            </ul>
          </div>
        </div>
        <div className="image-section">
          <img
            src={Image3}
            alt="Description for Image3"
            className="top-image"
          />
          <div className="bottom-images">
            <img
              src={Image4}
              alt="Description for Image4"
              className="bottom-left-image"
            />
            <img
              src={Image5}
              alt="Description for Image5"
              className="bottom-right-image"
            />
          </div>
        </div>
      </div>
      <div className="landing-quote">
        <p className="contactus">Bonded & Insured</p>
        <button className="landing-quote-btn" onClick={handleButtonClick}>
          <MessageSquare />
          Book Online Now!
        </button>
        <p className="contactus">Free Consultations</p>
      </div>
    </div>
  )
}

export default Gutters
